export default __webpack_public_path__ + "static/media/course.69547cf4.png";